  export class Prompt {
    /**
     * Define the prompt.
     * 
     * @param id The id of the prompt.
     * @param name The name of the prompt.
     * @param description The description of the prompt.
     */

    constructor(public id: string | null,
                public template_id: string,
                public name: string,
                public description: string) {}
  }
  